import React, { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
// @ts-ignore
import InvitationManagement from "./Features/Components/Invitations/InvitationManagement.tsx";
import { useUserContext } from "./Contexts/UserProvider";
import { useInvitationManagement } from "./Features/Services/InvitationManagement";
import { useGlobalUsers } from "./Features/Services/UserManagement";
import { ShieldAlert } from "lucide-react";
import { SidebarProvider, SidebarTrigger } from "./components/ui/sidebar"
import AppSideBar from "./Features/Components/NavBar/AppSideBar";
import TopNavbar from "./Features/Components/NavBar/TopNavBar";
import { useUIContext } from "./Contexts/UIProvider";

const Layout = (props) => {
  const [isContentLoad, setIsContentLoad] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const { isInvitation, setIsInvitation } = useUIContext();
  const { getInvitations } = useInvitationManagement();
  const { searchUsers } = useGlobalUsers();
  const { id } = useParams();
  const { user } = useUserContext();

  useEffect(() => {
    getUserDetails();
    getAllInvitations();
  }, [id, user?.email]);

  const getUserDetails = async () => {
    try {
      if (user?.email) {
        const userDetails = await searchUsers(user?.email);
        if (userDetails?.status === 500) {
          setIsAuthorized(false);
          return;
        }
        setIsAuthorized(true);
      }
    } catch (error) {
      setIsAuthorized(false);
      console.log("User Details Error : ", error);
    }
  };

  const getAllInvitations = async () => {
    if (user?.email) {
      const response: any = await getInvitations(user?.email);
      if (response?.length > 0) {
        setIsInvitation(true);
      }
    }
  };

  return (
    <>
      <SidebarProvider>
        <>
          <AppSideBar
            route={props?.routeType}
            setIsContentLoad={setIsContentLoad}
          />
          <main className="w-full">
            <TopNavbar />
            {/* <SidebarTrigger />   */}
            {isContentLoad ? (
              <>
                {isAuthorized ?
                  (<Outlet />)
                  :
                  (<div className="flex flex-col justify-center items-center h-screen text-center">
                    <ShieldAlert className="w-16 h-16 text-red-500 mb-6" />

                    {/* Text */}
                    <h1 className="text-2xl font-bold mb-2">
                      You are not authorized to access this page.
                    </h1>
                    <p className="text-lg mb-1">
                      Your organization’s approval is pending.
                    </p>
                    <p className="text-lg">
                      Please contact the support team to complete the approval process.
                    </p>
                  </div>)
                }
              </>
            ) : (
              <div className="flex justify-center items-center h-screen">
                <CircularProgress />
              </div>
            )}
          </main>
        </>


      </SidebarProvider>

      <InvitationManagement
        isInvitation={isInvitation}
        setIsInvitation={setIsInvitation}
      ></InvitationManagement>
    </>
  );
};

export default Layout;
